__turbopack_context__.v({
  "container": "styles-module__75QcaG__container" + " " + __turbopack_context__.i(576919)["container"],
  "popularContainer": "styles-module__75QcaG__popularContainer",
  "popularPillsContainer": "styles-module__75QcaG__popularPillsContainer",
  "popularTitle": "styles-module__75QcaG__popularTitle",
});
